import { render, staticRenderFns } from "./RoadPricesBasedByOrganisationalLocationView.vue?vue&type=template&id=08cf00a9&"
import script from "./RoadPricesBasedByOrganisationalLocationView.vue?vue&type=script&lang=js&"
export * from "./RoadPricesBasedByOrganisationalLocationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports